export default (array, partitionSize) => {
  if (partitionSize < 1) {
    throw new Error(`${partitionSize} is not a valid partitionSize`);
  }

  return array.reduce((acc, item, index) => {
    const lastPartition = acc[acc.length - 1];
    return index % partitionSize === 0
      ? [...acc, [item]]
      : [...acc.slice(0, -1), [...lastPartition, item]];
  }, []);
};
